import { Config } from '../common/types/config';

export default () => window.config || ({} as Config);
